import React from 'react';
import Contact from '../contacts/Contact';

const Enquiry = () => {
	console.log('Enquiry');
	return (
		<div>
			<Contact />
		</div>
	);
};

export default Enquiry;
